export class VillagesModel {
    constructor(public id: string, public name: string, public subdistrict_id: string){}
}